import "./newProcedure.css"

export const NewProcedure = () => {
	const handleDPUclick = () => {
		window.open("/dpu/new", "_blank")
	}

	const handleOPUclick = () => {
		window.open("/opu/new", "_blank")
	}

	const CentroHistorico = [
		{ label: "Restauración", link: "/urban/info/centro-Historico" },
		{ label: "Conservación", link: "/urban/info/centro-Historico" },
		{ label: "Remodelación", link: "/urban/info/centro-Historico" },
		{ label: "Publicidad exterior visual", link: "/urban/info/centro-Historico" },
	]

	const PlaneamientoList = [
		{ label: "Anteproyecto", link: "/urban/info/anteproyecto" },
		{ label: "Proyecto Definitivo", link: "/urban/info/proyecto-definitivo" },
		{ label: "Urbanización-Lotificación", link: "/urban/info/urbanizacion" },
		{ label: "Cambio de uso de suelo", link: "/urban/info/cambio-suelo" },
		{ label: "Demoliciones", link: "/urban/info/demolicion" },
		{ label: "Proyectos Especiales", link: "/arbitrios" },
		{ label: "Verja Perimetral", link: "/urban/info/verjas" },
		{ label: "Remodelación y Reconstrución", link: "/urban/info/remodelacion" },
	]

	const OpuList = [
		{ label: "Cierre de calle", link: "/urban/info/cierre-calle" },
		{ label: "Uso de acera", link: "/urban/info/uso-de-acera" },
		{ label: "Uso de parques", link: "/urban/info/uso-de-parques" },
		{ label: "Telecomunicaciones", link: "/urban/info/telecomunicaciones" },
		{ label: "Certificación uso de suelo", link: "/urban/info/certificado-suelo" },
		{ label: "Publicidad exterior", link: "/arbitrios" },
		{ label: "Certificado UGAM", link: "/urban/info/UGAM" },
		{ label: "Preferencia de vía", link: "/urban/info/preferencia-de-via" },
		{ label: "Rotura de calle", link: "/urban/info/cierre-calle" },
		{ label: "Renovación de certificaciones", link: "/arbitrios" },
	]

	return (
		<div className="HomeP">
			<div>
				<h1>Proyectos de construcción</h1>
				<ul>
					{PlaneamientoList.map((item, index) => (
						<li key={index}>
							<a href={item.link}>{item.label}</a>
						</li>
					))}
				</ul>
				<button className="process" onClick={handleDPUclick}>
					Solicitar trámite
				</button>
			</div>
			<div className="Tramite">
				<h1>Trámites y Tasas</h1>
				<ul>
					{OpuList.map((item, index) => (
						<li key={index}>
							<a href={item.link}>{item.label}</a>
						</li>
					))}
				</ul>
				<button className="process" onClick={handleOPUclick}>
					Solicitar trámite
				</button>
			</div>
			<div>
				<h1>Centro Histórico </h1>
				<ul className="CHD">
					{CentroHistorico.map((item, index) => (
						<li key={index}>
							<a href={item.link}>{item.label}</a>
						</li>
					))}
				</ul>
				<button className="process" onClick={handleDPUclick}>
					Solicitar trámite
				</button>
			</div>
		</div>
	)
}
